/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_company = /** @type {(inputs: {}) => string} */ () => {
	return `Společnost`
};

const da_company = /** @type {(inputs: {}) => string} */ () => {
	return `Firma`
};

const de_company = /** @type {(inputs: {}) => string} */ () => {
	return `Firma`
};

const en_company = /** @type {(inputs: {}) => string} */ () => {
	return `Company`
};

const es_company = /** @type {(inputs: {}) => string} */ () => {
	return `Empresa`
};

const fr_company = /** @type {(inputs: {}) => string} */ () => {
	return `Société`
};

const hu_company = /** @type {(inputs: {}) => string} */ () => {
	return `Vállalat`
};

const it_company = /** @type {(inputs: {}) => string} */ () => {
	return `Azienda`
};

const nl_company = /** @type {(inputs: {}) => string} */ () => {
	return `Bedrijf`
};

const pl_company = /** @type {(inputs: {}) => string} */ () => {
	return `Firma`
};

const pt_company = /** @type {(inputs: {}) => string} */ () => {
	return `Empresa`
};

const sv_company = /** @type {(inputs: {}) => string} */ () => {
	return `Företag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const company = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.company(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("company", locale)
	if (locale === "cs") return cs_company(inputs)
	if (locale === "da") return da_company(inputs)
	if (locale === "de") return de_company(inputs)
	if (locale === "en") return en_company(inputs)
	if (locale === "es") return es_company(inputs)
	if (locale === "fr") return fr_company(inputs)
	if (locale === "hu") return hu_company(inputs)
	if (locale === "it") return it_company(inputs)
	if (locale === "nl") return nl_company(inputs)
	if (locale === "pl") return pl_company(inputs)
	if (locale === "pt") return pt_company(inputs)
	return sv_company(inputs)
};